import { Notice, Spinner, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ITranslateStore } from '../../../stores/TranslateStore';
import UnpaidInvoicesFailedToLoadNotice from '../notices/UnpaidInvoicesFailedToLoadNotice';
import UnpaidAmountWithButton from '../UnpaidAmountWithButton';

import UnsettledReceivablesStore from '../../../stores/UnsettledReceivablesStore';
import UnpaidInvoicesTable from './UnpaidInvoicesTable';

interface IUnpaidInvoicesProps {
  translateStore?: ITranslateStore;
  unsettledReceivablesStore?: UnsettledReceivablesStore;
}

@inject('unsettledReceivablesStore', 'translateStore')
@observer
export default class UnpaidInvoices extends React.Component<IUnpaidInvoicesProps> {
  public componentDidMount(): void {
    this.props.unsettledReceivablesStore.tryLoadUnsettledReceivables();
  }

  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const unsettledReceivablesStore = this.props.unsettledReceivablesStore;

    if (unsettledReceivablesStore.unsettledReceivables.isFinished && unsettledReceivablesStore.allInvoicesPaid) {
      return null;
    }

    return (
      <React.Fragment>
        <Text className="text__margin-double">
          <h2 className="h3">{translate('invoices.unpaid-invoices.title')}</h2>
          {this.unpaidInvoicesTable()}
        </Text>
      </React.Fragment>
    );
  }

  private unpaidInvoicesTable() {
    const unsettledReceivablesStore = this.props.unsettledReceivablesStore;

    if (unsettledReceivablesStore.unsettledReceivables.isInitialLoading) {
      return <Spinner />;
    }

    if (unsettledReceivablesStore.unsettledReceivables.isFinishedWithError) {
      return <UnpaidInvoicesFailedToLoadNotice />;
    }

    return (
      <React.Fragment>
        {unsettledReceivablesStore.totalAmountToPay === 0 ? this.toBeSettledByPrepaymentNotice() : null}
        <UnpaidInvoicesTable />
        <UnpaidAmountWithButton />
      </React.Fragment>
    );
  }

  private toBeSettledByPrepaymentNotice() {
    const translate = this.props.translateStore.translate;
    return (
      <Notice type="success" size="small">
        {translate('invoices.unpaid-invoices.notices.to-be-settled-by-prepayment')}
      </Notice>
    );
  }
}
